import {
  RESET_STORE,
  SET_ALL_STORES,
  SET_BUSINESS_DETAILS,
  SET_BUSINESS_ADDRESS,
  SET_ACTIVE_STORE_NUM,
  SET_CUSTOMER_LIST_STATUS,
} from "../types";

const initialState = {
  address: {},
  allStores: [],
  businessDetails: {},
  isMoreThanTwoStores: false,
  isCustomerListDisabled: false,
};

const store = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_STORES:
      return {
        ...state,
        allStores: action.payload,
      };
    case SET_BUSINESS_DETAILS:
      return {
        ...state,
        businessDetails: action.payload,
      };
    case SET_BUSINESS_ADDRESS:
      return {
        ...state,
        address: action.payload,
      };
    case SET_ACTIVE_STORE_NUM:
      return {
        ...state,
        isMoreThanTwoStores: action.payload,
      };
    case SET_CUSTOMER_LIST_STATUS:
      return {
        ...state,
        isCustomerListDisabled: action.payload,
      };
    case RESET_STORE:
      return initialState;
    default:
      return state;
  }
};

export default store;
